import React from 'react'
import { ChevronLeftIcon } from '@toasttab/buffet-pui-icons'
import { ModalCloseButton } from 'shared/components/common/modal'
import { t } from 'src/translations'

interface Props {
  // When provided, a back chevron shows on the leading edge. Omit on the top-level screen.
  onBack?: () => void
}

// Shared header for every recovery screen (D1/D2/D3): optional back chevron + × close over a
// divider. Intentionally NO title — the Intercom panel that follows shows its own.
export const RecoveryModalHeader = ({ onBack }: Props) => (
  <div className='recoveryModalHeader'>
    <div className='recoveryModalHeaderSide'>
      {onBack && (
        <button
          type='button'
          className='modalIconButton'
          data-testid='recovery-back'
          aria-label={t('order-confirmation.recovery.back')}
          onClick={onBack}
        >
          <ChevronLeftIcon accessibility='decorative' />
        </button>
      )}
    </div>
    <div className='recoveryModalHeaderSide recoveryModalHeaderSide--end'>
      <ModalCloseButton />
    </div>
  </div>
)

export default RecoveryModalHeader
